import React, { useMemo } from 'react'
import { generateTagHtml } from '../utils/printTag'

function toPreviewProduct(product) {
  const source = product || {}
  const variant = source?.variants?.[0] || {}
  const tagPrintInfo = String(source?.tagPrintInfo || source?.metafields?.tag_print_info || '').trim().slice(0, 24)

  return {
    title: source?.title || '',
    price: variant?.price || source?.salePrice || source?.price || '0',
    sku: variant?.sku || source?.sku || '',
    barcode: variant?.barcode || source?.barcode || '',
    weight: variant?.weight || source?.weight || source?.metafields?.weight || '',
    karat: source?.karat || source?.metafields?.karat || '',
    productType: source?.productType || '',
    tagPrintInfo,
    metafields: {
      ...(source?.metafields || {}),
      tag_print_info: tagPrintInfo
    }
  }
}

const TagPreview = ({ tagConfig, product }) => {
  const previewProduct = useMemo(() => toPreviewProduct(product), [product])
  const previewHtml = useMemo(
    () => generateTagHtml([previewProduct], tagConfig, { preview: true }),
    [previewProduct, tagConfig]
  )

  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full rounded-lg border border-border/60 bg-muted/20 overflow-hidden">
        <iframe
          title="Label print preview"
          srcDoc={previewHtml}
          className="w-full h-[96px] bg-transparent"
        />
      </div>
      <span className="text-xs text-muted-foreground mt-2">2.25" x 0.5" Zebra ZSB sample reference preview</span>
    </div>
  )
}

export default TagPreview
